module.exports = __webpack_public_path__ + "assets/img/douying.fbfb7b07.png";